var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlluPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000.84 836.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4940",
    "data-name": "Path 4940",
    d: "M419.57,62.77c30.78-27.43,79.11-33,123.09-30.84,138.16,6.87,262.87,73.56,370.74,149,39.05,27.31,77.5,56.74,102.85,94.35,51.6,76.57,36.3,182.63-35.46,245.7-24.41,21.46-54,37.92-84.39,52.5-54,25.93-112.31,46.74-173.62,52.67-43.73,4.22-88,.79-131.46-5.11-121.44-16.47-240.65-52.89-340.56-115.2-43.82-27.33-85.13-61.3-103.19-105.51s-6.5-100.24,38.24-126.41c18.51-10.82,40.64-15.71,62.3-20.3,31.89-6.76,64.29-13.42,93.06-27.15,29.72-14.19,64.92-41.63,59-73C393.89,119.76,388.82,90.17,419.57,62.77Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1028",
    "data-name": "Ellipse 1028",
    cx: 33.42,
    cy: 5.65,
    rx: 33.42,
    ry: 5.65,
    transform: "translate(934 825.69)",
    fill: "#4b55f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1029",
    "data-name": "Ellipse 1029",
    cx: 148.72,
    cy: 26.33,
    rx: 148.72,
    ry: 26.33,
    transform: "translate(244.72 735.35)",
    fill: "#4b55f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1030",
    "data-name": "Ellipse 1030",
    cx: 75.59,
    cy: 16.65,
    rx: 75.59,
    ry: 16.65,
    transform: "translate(717.22 739.82)",
    fill: "#4b55f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4941",
    "data-name": "Path 4941",
    d: "M1073.9,791.49s6.14,8-2.83,20.14-16.36,22.35-13.37,29.9c0,0,13.53-22.5,24.54-22.82S1086,805,1073.9,791.49Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4942",
    "data-name": "Path 4942",
    d: "M1073.9,791.49a10,10,0,0,1,1.26,2.52c10.74,12.63,16.47,24.41,6.14,24.7-9.62.28-21.17,17.49-23.93,21.83a8.2,8.2,0,0,0,.33,1s13.53-22.5,24.54-22.82S1086,805,1073.9,791.49Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4943",
    "data-name": "Path 4943",
    d: "M1085.31,801.72c0,2.83-.32,5.11-.71,5.11s-.71-2.28-.71-5.11.4-1.49.79-1.49S1085.31,798.9,1085.31,801.72Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4944",
    "data-name": "Path 4944",
    d: "M1089.23,805.09c-2.48,1.35-4.65,2.17-4.83,1.83s1.67-1.72,4.15-3.07,1.5-.37,1.69,0S1091.71,803.74,1089.23,805.09Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4945",
    "data-name": "Path 4945",
    d: "M1041.49,791.49s-6.14,8,2.83,20.14,16.37,22.35,13.38,29.9c0,0-13.54-22.5-24.55-22.82S1029.37,805,1041.49,791.49Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4946",
    "data-name": "Path 4946",
    d: "M1041.49,791.49a9.828,9.828,0,0,0-1.25,2.52c-10.75,12.63-16.48,24.41-6.15,24.7,9.63.28,21.17,17.49,23.93,21.83-.09.34-.2.67-.32,1,0,0-13.54-22.5-24.55-22.82S1029.37,805,1041.49,791.49Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4947",
    "data-name": "Path 4947",
    d: "M1030.08,801.72c0,2.83.32,5.11.71,5.11s.71-2.28.71-5.11-.4-1.49-.79-1.49S1030.08,798.9,1030.08,801.72Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4948",
    "data-name": "Path 4948",
    d: "M1026.17,805.09c2.48,1.35,4.64,2.17,4.83,1.83s-1.68-1.72-4.16-3.07-1.5-.37-1.68,0S1023.69,803.74,1026.17,805.09Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ffd037"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4949",
    "data-name": "Path 4949",
    d: "M1032,840.48s17.15-.53,22.32-4.21,26.4-8.08,27.68-2.17,25.78,29.37,6.41,29.52-45-3-50.17-6.16S1032,840.48,1032,840.48Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    d: "M1088.8,861.57c-19.37.15-45-3-50.17-6.16-3.93-2.4-5.5-11-6-14.95h-.57s1.08,13.84,6.24,17,30.8,6.32,50.17,6.16c5.59,0,7.52-2,7.42-5C1095.09,860.42,1093,861.53,1088.8,861.57Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1031",
    "data-name": "Ellipse 1031",
    cx: 33.42,
    cy: 5.65,
    rx: 33.42,
    ry: 5.65,
    transform: "translate(0 783.69)",
    fill: "#4b55f6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    d: "M110.55,794.59s19.07-.59,24.81-4.68,29.33-9,30.76-2.41,28.65,32.63,7.13,32.81-50-3.36-55.75-6.85S110.55,794.59,110.55,794.59Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4952",
    "data-name": "Path 4952",
    d: "M173.63,818c-21.53.17-50-3.35-55.75-6.85-4.37-2.66-6.11-12.2-6.69-16.61h-.64s1.21,15.38,7,18.87,34.22,7,55.75,6.85c6.21,0,8.36-2.27,8.24-5.54C180.62,816.75,178.25,818,173.63,818Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1032",
    "data-name": "Ellipse 1032",
    cx: 36.41,
    cy: 6.16,
    rx: 36.41,
    ry: 6.16,
    transform: "translate(119.89 804.37)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4953",
    "data-name": "Path 4953",
    d: "M270.93,832a10.6,10.6,0,0,0,3.48-5.24c.44-2.08-.44-4.58-2.43-5.34-2.23-.85-4.61.7-6.41,2.26s-3.88,3.34-6.24,3a9.51,9.51,0,0,0,2.94-8.89,3.67,3.67,0,0,0-.82-1.8c-1.24-1.33-3.48-.76-5,.28-4.71,3.32-6,9.71-6.05,15.47-.47-2.08-.07-4.24-.09-6.37s-.59-4.49-2.39-5.64a7.23,7.23,0,0,0-3.65-.86c-2.11-.07-4.47.14-5.92,1.69-1.79,1.92-1.33,5.15.23,7.27s3.94,3.44,6.13,4.9a13.569,13.569,0,0,1,4.38,4.18,4.707,4.707,0,0,1,.33.75h13.27A36.9,36.9,0,0,0,270.93,832Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4954",
    "data-name": "Path 4954",
    d: "M412.48,469.54l-6.16-1.83.29,4.48,13.79,5.27-2.5-7.42Z",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4955",
    "data-name": "Path 4955",
    d: "M412.48,469.54l-6.16-1.83.29,4.48,13.79,5.27-2.5-7.42Z",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M708.21,701.25A283.491,283.491,0,0,0,790,501.63v-2.41H506.18Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M708.21,701.25A283.491,283.491,0,0,0,790,501.63v-2.41H506.18Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M708.21,705.72A283.49,283.49,0,0,0,790,506.1c0-.81,0-1.61,0-2.41H506.18Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4959",
    "data-name": "Path 4959",
    d: "M708.21,705.72A283.49,283.49,0,0,0,790,506.1c0-.81,0-1.61,0-2.41H506.18Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4960",
    "data-name": "Path 4960",
    d: "M966.38,456,962,416.47s-7.93-35.59-9.06-53.38S943.24,344,943.17,344h0s-10.57-6.18-11.51-8.24c-.73-1.58-6.6-4.94-9.26-6.42l-1.3-.69s-3.3-13.75-7.23-11.78l-.32-.93a34.411,34.411,0,0,1-1.85-9.17c0-.39,0-.77,0-1.15a33.56,33.56,0,0,0,9-15.33,33.145,33.145,0,0,0,1-6.26c0-.39,0-.79,0-1.19,1.93-1.35,2.25-4.21,2.76-6.6.94-4.38,3.4-8.3,4.57-12.62.1-.37.18-.75.25-1.14v-.25a14.785,14.785,0,0,0,.23-2.4c0-.06,0-.11,0-.17,0-3.26-1-6.46-3.7-8.2a8,8,0,0,1-1.72-1.2,5.149,5.149,0,0,1-.88-1.59l-2-4.76a4.931,4.931,0,0,0-1-1.69,7.25,7.25,0,0,0-2.67-1.27c-3-1.15-5-3.94-6.47-6.72s-2.82-5.78-5.11-8c-3.72-3.55-9.24-4.3-14.36-4.86a15.492,15.492,0,0,0-.36,4.89c-8.13-1.78-17-3.49-24.49.1a5.67,5.67,0,0,0-3,2.9h0a4.047,4.047,0,0,0-.12.47h0a3.1,3.1,0,0,0,0,.61,5.5,5.5,0,0,1,.13,1.33,2,2,0,0,1-1.25,1.34c-2.46,1.09-5.43-.32-8,.55-2.35.8-3.65,3.27-4.38,5.63s-1.2,4.89-2.79,6.78c-.8,1-1.85,1.67-2.68,2.6a8,8,0,0,0-1.89,6.36,1.122,1.122,0,0,0,0,.18,3.616,3.616,0,0,0,.19.9,8.124,8.124,0,0,0,.38,1c.14.29.29.57.45.85h0c1.12,1.89,2.79,3.53,3.21,5.67v.08c.49,2.75-1.26,5.37-1.7,8.11h0c0,.22-.06.43-.07.65v.74c.15,4,3.82,6.65,6,9.59.58.78,1.66,3.05,2.82,3.9.06.43.13.85.22,1.26a32.628,32.628,0,0,0,3.26,9.3A34,34,0,0,0,875,312.79c0,.39.08.79.12,1.19,0,.74.1,1.5.1,2.24v1.08l-.33-2.54a9.831,9.831,0,0,0-3.76-.05,288.33,288.33,0,0,0-197.78-78.55V374.25c-8.26-2.48-15-2.76-14.5,3.08.46,6,7,12.08,14.5,17.11V525.53H817.59c.15,3.34.45,6.34,1,7.07C820.14,534.48,820,557,820,557s.76,4.13.95,4.87,2.45,19.86,2.45,20.79,2.08,7.5,1.89,10.12,3.4,11.23,3.4,11.23l.56,15.74s5.85,8.81,6.23,9.37.19,11.61,6.6,16.86a7.46,7.46,0,0,1,2.08,3.55c.48,1.9,16.58,28.94,21.56,37.28l-.6,2.83-4,18.71-.19,7.87s-2.46,6.74-1.7,9.55a10.25,10.25,0,0,1,.38,4.5s-2.64,4.11-.94,6.74.75,4.12-1.7,10.86c-1.08,3-.15,4.77,1.23,5.87a8.278,8.278,0,0,1-.12,1c-.35,3-.74,6.43-.74,7.34s-.35,5-.37,8.6c0,2.85.18,5.41.94,5.83,1.7.93,11.14,2,11.32,5.24s3.78,7.86,11.32,7.86,20.57-2.62,23.77-2.25c.53.07.84-.28,1-.9a2.982,2.982,0,0,0,.07-.32,7.14,7.14,0,0,0,4.4,2.35c11.32,2.07,25.09-3,27.74-8.05a9.244,9.244,0,0,0,.76-2c1.26-5-.76-11.29-.76-11.29a19.261,19.261,0,0,1-.24-7.74,6.59,6.59,0,0,1,1.55-3.11c1.81-1.9,3.56-7.12,4.74-11.32.91-3.27,1.49-5.93,1.49-5.93s-1.19-1.82-3-4.32h0c-3.63-5.09-9.76-13-13.59-14.35a4.392,4.392,0,0,1-.4-1.18c-.18-1.87-4.15-8-4.15-8s-5.47-8.81-5.47-9.55-7.54-12.18-7.54-12.18-2.9-6.29-4.81-9.7c.22-.6.44-1.36.67-2.26,2-7.88,4-25.87,3.57-28.31-.57-3-1-6.18,1.88-10.49s2.65-11.23,2.65-11.23-.19-21.18,1.88-25.48,7.92-38.77,7.74-39.53S926,557,926,557l.35-13.59v-.83s1.32-11.8,3-14.43a6.28,6.28,0,0,0,.52-2.57H961c0-1.88-.07-3.75-.12-5.62H961a285.851,285.851,0,0,0-3-39.17c2.92-3.54,6.45-6,6.56-6.76a41.645,41.645,0,0,1,2.07-6.75C967.89,463.49,966.38,456,966.38,456ZM903.55,749.13s.8-.48,2.1-1.15c.08.32.16.66.24,1,.84,3.62,1.85,8.64,1.62,11-.39,3.93-1,10.12-1,10.12a32.8,32.8,0,0,0-2.39,7c-.6-2.47-1.19-4.42-1.19-4.42s-12.84-8.6-12.84-12.92a33.861,33.861,0,0,0-.88-6.43h0c-.11-.54-.23-1.06-.35-1.57a11.234,11.234,0,0,1,1.42,2.21s3.83-9.29,4.75-13a3,3,0,0,0,.16-1.42,12.143,12.143,0,0,1-.23-3.84c.9,1,1.59,2,1.36,2.72C895.8,740.14,903.55,749.13,903.55,749.13Z",
    transform: "translate(-99.58 -31.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4961",
    "data-name": "Path 4961",
    d: "M904.59,788.35c-3.16-.37-16,2.23-23.46,2.23s-11-4.64-11.17-7.82-9.49-4.27-11.17-5.2c-.74-.42-.93-3-.92-5.8,0-3.57.36-7.61.36-8.55s.38-4.32.73-7.29c.3-2.57.58-4.8.58-4.8,8.75-10.61,28.68-2.8,28.68-2.8s.85,2.95,1.54,6.25h0a34.219,34.219,0,0,1,.87,6.39c0,4.29,12.67,12.85,12.67,12.85a84.559,84.559,0,0,1,2.1,8.83C905.91,785.79,906,788.52,904.59,788.35Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    d: "M904.59,788.34c-3.16-.36-16,2.24-23.45,2.24s-11-4.65-11.17-7.82-9.5-4.28-11.18-5.21c-.74-.41-.93-3-.92-5.79,3.56,1.08,8.52,2.85,10.24,4.68,2.79,3,3.53,6.32,5.4,6.7s3.72,3,12.65.74c5.58-1.4,13.82-1.41,19.24-1.22C905.91,785.79,906,788.51,904.59,788.34Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4963",
    "data-name": "Path 4963",
    d: "M938.66,757.45c-3.16,3.35-1.29,10.79-1.29,10.79s2.6,8.2,0,13.23-16.2,10-27.37,8a6.57,6.57,0,0,1-5.08-3.48c-2.73-5.38,1.91-14.77,1.91-14.77s.56-6.14.94-10.05c.22-2.36-.78-7.35-1.6-10.95-.55-2.36-1-4.13-1-4.13s17-24.39,22.16-24.57a2.336,2.336,0,0,1,.73.08c3.74.92,10.11,9.18,13.82,14.41,1.77,2.5,2.95,4.31,2.95,4.31S941.84,754.1,938.66,757.45Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4964",
    "data-name": "Path 4964",
    d: "M938.66,757.45c-3.16,3.35-1.29,10.79-1.29,10.79s2.6,8.2,0,13.22-16.2,10.06-27.37,8a6.58,6.58,0,0,1-5.08-3.47c3.22-.68,8.29-1.55,16.25-2.48,19.17-2.24,14.14-14.89,14.14-14.89s-2.23-8.94.56-13.41c2-3.17,4.63-13.5,6-19.2,1.78,2.49,2.95,4.3,2.95,4.3S941.84,754.1,938.66,757.45Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4965",
    "data-name": "Path 4965",
    d: "M889.76,754.57c-2.67-3.65-10.57-10.68-26.5,3.06a9,9,0,0,1-4.3-1.71c.3-2.57.58-4.8.58-4.8,8.75-10.61,28.68-2.8,28.68-2.8S889.07,751.27,889.76,754.57Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4966",
    "data-name": "Path 4966",
    d: "M926.38,545v.82L926,559.35s-1.68,4.66-1.49,5.4-5.58,35-7.64,39.28S915,629.36,915,629.36s.18,6.88-2.62,11.17S910,648,910.56,651c.46,2.42-1.55,20.31-3.52,28.14a9.79,9.79,0,0,1-1.33,3.51,2.767,2.767,0,0,0-.45.86c-2.68,6.91-9.6,49.59-9.6,49.59s-.07.82-.14,1.94c-.12,2.06-.23,5.16.14,5.88a3,3,0,0,1-.16,1.41c-.9,3.69-4.68,12.93-4.68,12.93s-7.26-16.2-27.56,1.3c0,0-7.82-.75-5.39-7.45s3.35-8.19,1.67-10.79.93-6.7.93-6.7a10.191,10.191,0,0,0-.37-4.47c-.75-2.79,1.68-9.49,1.68-9.49l.19-7.82,3.92-18.6,1.18-5.6,1.22-5.79L874.79,567l.25-4.2,1.82-31.69,43.93-7.26,1.5,11.53,2.38,5.66Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#b3d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4967",
    "data-name": "Path 4967",
    d: "M905.59,543.28,878.68,561l1,15.51s2.79,24.95,2.79,27.55-1.31,23.83-1.31,23.83,6.71,10,6,12.48,5.76,9.3,5.76,9.3L904,670.87s1.87,6.92,3,8.22a9.791,9.791,0,0,1-1.33,3.51c-2.23,2.23-10.05,50.45-10.05,50.45s-.07.82-.14,1.94c-.57-.51-1-.82-1-.82s-5.4-8.94-5.4-9.86-5.77-8.38-5.77-8.38L870.15,690.8l-3.08-5.21,1.22-5.79,8.57-148.74,43.93-7.26,1.5,11.53-40,10.19Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4968",
    "data-name": "Path 4968",
    d: "M924.14,545,875,562.75l1.82-31.69,43.93-7.26,1.5,11.53,2.38,5.66C924.33,543.28,924.14,545,924.14,545Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M895.66,740.87a3,3,0,0,1-.16,1.41,4.864,4.864,0,0,1-1-2.52c.56-1.68-4.47-5.59-4.47-5.59s-5.39-8.94-5.39-9.86-5.78-8.38-5.78-8.38l-13-24.74,1.18-5.6,1.22-5.79L874.79,567l.39,9.53S878,601.43,878,604s-1.3,23.83-1.3,23.83,6.7,10,6,12.48,5.77,9.3,5.77,9.3l11.17,21.23s2,7.64,3.17,8.38a19.582,19.582,0,0,1,2.52,4.21c-2.68,6.91-9.6,49.59-9.6,49.59s-.07.82-.14,1.94C895.4,737.05,895.29,740.15,895.66,740.87Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4970",
    "data-name": "Path 4970",
    d: "M933.27,730.63s-8.38,15.08-14.71,15.46c-4.27.25-9.47,2.61-12.39,4.13-.55-2.36-1-4.13-1-4.13s17-24.39,22.16-24.57a2.34,2.34,0,0,1,.73.08v.09C928.24,723.56,933.27,730.63,933.27,730.63Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4971",
    "data-name": "Path 4971",
    d: "M933.27,729.51s-8.38,15.08-14.71,15.46-14.7,5.4-14.7,5.4-7.64-8.94-7.09-10.61-4.46-5.59-4.46-5.59-5.4-8.94-5.4-9.86-5.78-8.38-5.78-8.38L867.92,690.8s-22.15-37.25-22.71-39.48a7.371,7.371,0,0,0-2.06-3.53c-6.32-5.22-6.14-16.2-6.51-16.76l-6.14-9.31-.56-15.64s-3.54-8.56-3.35-11.17-1.87-9.12-1.87-10.06-2.23-19.91-2.41-20.66-.94-4.84-.94-4.84.19-22.34-1.29-24.21c-.82-1-1.08-6.27-1.14-10.85-.06-3.83,0-7.2,0-7.2l109.65-11.36s.68,6.25,1.07,12.51c.35,5.59.47,11.21-.32,12.44-1.68,2.61-3,14.34-3,14.34l-49.52,17.87.55,13.59s2.8,24.95,2.8,27.55-1.31,23.83-1.31,23.83,6.7,10,6,12.48,5.76,9.3,5.76,9.3l11.17,21.23s2.06,7.64,3.17,8.38S911.12,691,911.12,691s7.44,11.37,7.44,12.11,5.4,9.5,5.4,9.5,3.91,6.14,4.09,8S933.27,729.51,933.27,729.51Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#b3d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    d: "M866.25,635.68s9.12,10.43,13.77,10.62S866.25,635.68,866.25,635.68Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    d: "M901.06,738.08s27.55-14.15,24-7.63-13.59,10-13.59,10Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    d: "M865.13,734.92s16.94,1.11,19.17,3.91C884.3,738.83,866.25,735.1,865.13,734.92Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    d: "M865.31,740.69s15.46.56,20.48,2.79C885.79,743.48,869.41,742.92,865.31,740.69Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4976",
    "data-name": "Path 4976",
    d: "M713,416l-4.9-2.24-7.76-3.54s-36.86-14.71-38-29.41,43,9.68,43,9.68a42.427,42.427,0,0,0,4.09,5.5c1.41,1.58,3,2.92,4.29,3.06C717.12,399.42,713,416,713,416Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4977",
    "data-name": "Path 4977",
    d: "M918,336.31l-12.1,14-29.41-9.67-7.26-5.78,4.64-6.14c1.59-2.1,2.07-5.3,2-8.6a16.8,16.8,0,0,0-.1-2.24,57.164,57.164,0,0,0-2.08-10.94s41.88-10.62,38.9-1.87a15.569,15.569,0,0,0-.7,5.63,34.113,34.113,0,0,0,1.83,9.12,52.993,52.993,0,0,0,3.15,7.59Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4978",
    "data-name": "Path 4978",
    d: "M912.6,305a15.569,15.569,0,0,0-.7,5.63,33.51,33.51,0,0,1-36.12,7.18,57.16,57.16,0,0,0-2.08-10.94S915.58,296.28,912.6,305Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4979",
    "data-name": "Path 4979",
    d: "M921.91,285.67a21.124,21.124,0,0,1-.09,2.39,33.51,33.51,0,0,1-63.12,13.15,32.879,32.879,0,0,1-3.21-9.24,32,32,0,0,1-.61-6.3,33.147,33.147,0,0,1,.46-5.49,33.5,33.5,0,0,1,66.53,4.34C921.9,284.9,921.91,285.29,921.91,285.67Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M918,336.31l-12.1,14-29.41-9.67-7.26-5.78,4.64-6.14c1.59-2.1,2.07-5.3,2-8.6l1.34,10.27.32.32,1.92,1.92h2.42l4.66,6.33s6.7-5.39,7.26-4.1,9.68-2.23,9.68-2.23h.35c8.26-.35,9.7-12.65,9.7-12.65a1.967,1.967,0,0,1,.2-.15,53,53,0,0,0,3.15,7.59Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M929.68,518.24c-.21.81-.44,1.6-.69,2.39-7.26,23.08-59.58,23.64-59.58,23.64l-1.49-14.33-5,9.68s-32.38-8.94-43.95-15.33c-.06-3.83,0-7.2,0-7.2l109.65-11.36S929.29,512,929.68,518.24Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4982",
    "data-name": "Path 4982",
    d: "M713,416l-4.9-2.24c1.13-5.32,1.33-15.88,1.36-17.77,1.41,1.58,3,2.92,4.29,3.06C717.12,399.42,713,416,713,416Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4983",
    "data-name": "Path 4983",
    d: "M928.05,465.89s8.2,29.42.94,52.51S869.41,542,869.41,542l-1.49-14.33-5,9.69s-39.09-10.81-46.72-17.14-3.73-15.82-3.73-15.82,2.61-12.28,4.84-14.9,2.61-11.73,1.86-13,2.61-13.6,3.73-15.46-.19-51.57-.19-51.57-16.57,7.44-17.5,9.68-20.48,13-20.48,13-18.43,2.24-21.78,2.24-21.79-2.24-21.79-2.24-5-.19-6.51-1.3a19.21,19.21,0,0,0-4.85-2.05s-5.2-1.12-6.7-3.16-14-8.94-14-8.94c2.42-1.49,2.61-21,2.61-21l23.64,5.77s1.5-3.16,3.73-1.86S754.91,402,754.91,402s11.36-2.23,11.92-1.31,2.23.75,2.23.75,2.24-.19,2.24-.92,2,.17,2,.17l3.73.56s-.56-4.83,1.12-5.2A2.46,2.46,0,0,0,780,394s5-6.7,7.45-6.7,4.1-6.7,4.1-6.7l8.94-9.12s-1.12-4.66,0-4.85,1.29-2.23,1.29-2.23.38-4.09,2.43-5,3.16-6.32,3.16-6.32,9.49-10.61,10.24-14.34,4.66-4.47,4.66-4.47a23,23,0,0,1,6.88-3c3.17-.56,11.55-1.5,11.55-1.5s15.26-1.29,16.76-3,4.09-1.5,5.76-1.5a1.91,1.91,0,0,0,1-.37c1.51-.94,3.31-3.56,5.11-5.21,2.23-2.05,6.14-1.12,6.14-1.12l1.68,12.85.31.31,1.92,1.92h2.42l4.66,6.34s6.7-5.4,7.26-4.1,9.68-2.24,9.68-2.24h.35c8.26-.35,9.7-12.64,9.7-12.64,4.1-3.55,7.64,11.36,7.64,11.36l1.29.69c2.62,1.46,8.42,4.8,9.13,6.38.93,2,11.36,8.18,11.36,8.18Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4984",
    "data-name": "Path 4984",
    d: "M932.9,510.57,927.4,515l-6.23,5s-11.55,27-27.37,19.37S915,503.5,915,503.5l5.12-2.48,5.67-2.74Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4985",
    "data-name": "Path 4985",
    d: "M876.42,334c-5.75,2.39-13,8.07-13,8.07l-.27-14.89c1.51-.95,3.31-3.56,5.11-5.22,2.23-2,6.14-1.11,6.14-1.11l1.68,12.84Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4986",
    "data-name": "Path 4986",
    d: "M877.54,331.78c-5.75,2.39-13,8.07-13,8.07L864.3,325c1.51-.94,3.31-3.56,5.11-5.21,2.23-2.05,6.14-1.12,6.14-1.12l1.68,12.85Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#e6eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4987",
    "data-name": "Path 4987",
    d: "M922.46,336.45c-2.86,7.66-6.42,16.14-7.06,12.89-.77-3.85-7.48-9.29-11.57-12.3,8.26-.34,9.7-12.64,9.7-12.64,4.1-3.54,7.64,11.36,7.64,11.36Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    d: "M922.46,333.1c-2.86,7.66-6.42,16.14-7.06,12.89-.77-3.85-7.48-9.29-11.57-12.3,8.26-.35,9.7-12.64,9.7-12.64,4.1-3.55,7.64,11.36,7.64,11.36Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#e6eaed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    d: "M884.49,627.12s21.22-3,20.29,1.49S884.49,627.12,884.49,627.12Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4990",
    "data-name": "Path 4990",
    d: "M850.23,554s8.38-4.47,15.83-2.6Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    "data-name": "Path 4991",
    d: "M836.64,541.85s13.41-2.05,18.43.19Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    "data-name": "Path 4992",
    d: "M895.29,572.57s-11.73,12.47-11,15.82Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    "data-name": "Path 4993",
    d: "M780.79,405.2s-1.86,6.7,9.5,9.49Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4994",
    "data-name": "Path 4994",
    d: "M777.44,416.74s14,12.47,7.45,12.85S777.44,416.74,777.44,416.74Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4995",
    "data-name": "Path 4995",
    d: "M808.53,366.66s17.13,11.91,16,14.71S808.53,366.66,808.53,366.66Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4996",
    "data-name": "Path 4996",
    d: "M932.9,510.57,927.4,515c-1.15-3.94-3.53-10.54-7.25-14l5.67-2.74Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4997",
    "data-name": "Path 4997",
    d: "M935.5,352.32l7.45-4.65s8.56,1.3,9.68,19,8.94,53.06,8.94,53.06L965.85,459s1.49,7.45.19,11.17a40.79,40.79,0,0,0-2,6.7c-.19,1.31-10.43,7.64-10.24,15.83s-13,15.82-13,15.82-8.57,5-11.36,8.57c0,0-3.17-14.9-10.05-18.62s14.52-33.32,14.52-33.32Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#53517c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4998",
    "data-name": "Path 4998",
    d: "M922.62,465.65s-22.34,9.31-20.48,12.29S922.62,465.65,922.62,465.65Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4999",
    "data-name": "Path 4999",
    d: "M922.62,477.56s-9.29,4.11-8.52,5.42S922.62,477.56,922.62,477.56Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5000",
    "data-name": "Path 5000",
    d: "M917.41,485.38s-9.29,4.11-8.52,5.42S917.41,485.38,917.41,485.38Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5001",
    "data-name": "Path 5001",
    d: "M676.68,246.08v282H960.51C959.22,372.33,832.71,246.4,676.68,246.08Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5002",
    "data-name": "Path 5002",
    d: "M676.68,246.08v282H960.51C959.22,372.33,832.71,246.4,676.68,246.08Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5003",
    "data-name": "Path 5003",
    d: "M676.68,240.5v282H960.51C959.22,366.74,832.71,240.81,676.68,240.5Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5004",
    "data-name": "Path 5004",
    d: "M895.34,530.39a7.34,7.34,0,0,1,1.32-4.32,7.05,7.05,0,0,1,3.18-1.78c1.06-.35,2.13-.68,3.2-1a8.151,8.151,0,0,1,2.58-.42c1.78.07,3.32,1.17,4.75,2.22a2,2,0,0,1,.68.71c.32.74-.37,1.51-1,2a47.656,47.656,0,0,1-7.11,5.23c-1.78,1-4.14,2.13-6.23,2.15C894.14,535.25,895.17,532.25,895.34,530.39Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#c37871"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5005",
    "data-name": "Path 5005",
    d: "M921.91,285.67a21.124,21.124,0,0,1-.09,2.39,4.621,4.621,0,0,1-.44.26,12.9,12.9,0,0,0-1.65.73c-1.63,1.11-1.26,3.53-1.11,5.49a14.79,14.79,0,0,1-1.7,8.19,2.93,2.93,0,0,1-2.59-2.44,19.589,19.589,0,0,1-.16-3.83c-.16-3.42-2-6.47-3.2-9.69-2.22-6.17-1.73-13-3.21-19.37-.43-1.88-1.13-3.88-2.73-5-2.12-1.46-5.06-.82-7.34.37s-4.32,2.93-6.79,3.68c-3.81,1.15-7.86-.24-11.65-1.42s-8.08-2.18-11.62-.37c-3.72,1.91-5.39,6.26-6.53,10.3a10.1,10.1,0,0,0-.53,3.44,30.848,30.848,0,0,1,.43,3.1c0,2.24-1.91,4-2.65,6.12-.46,1.31-.35,4.54-2.25,4.52a1.21,1.21,0,0,1-.61-.19,32,32,0,0,1-.61-6.3,33.16,33.16,0,0,1,.46-5.49,33.5,33.5,0,0,1,66.53,4.34C921.9,284.9,921.91,285.29,921.91,285.67Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5006",
    "data-name": "Path 5006",
    d: "M846.55,277.3c-.12-3.23,2.33-6.25,1.77-9.43-.44-2.49-2.6-4.3-3.65-6.6a8,8,0,0,1,1.27-8.43c.82-.92,1.85-1.64,2.64-2.58,1.57-1.88,2-4.41,2.75-6.75s2-4.79,4.33-5.59c2.51-.86,5.45.54,7.87-.55a2,2,0,0,0,1.23-1.32,4.66,4.66,0,0,0-.13-1.33c-.17-1.78,1.52-3.17,3.14-3.95,7.4-3.57,16.14-1.87,24.16-.1a15.893,15.893,0,0,1,.35-4.86c5.06.56,10.51,1.3,14.17,4.82,2.27,2.19,3.54,5.17,5,7.93s3.46,5.53,6.39,6.68a7.1,7.1,0,0,1,2.64,1.26,5,5,0,0,1,1,1.68l1.92,4.73a5.261,5.261,0,0,0,.88,1.59,8.152,8.152,0,0,0,1.69,1.19c3.72,2.43,4.27,7.78,3.11,12.08s-3.58,8.19-4.5,12.55c-.54,2.57-.85,5.71-3.2,6.88a13.6,13.6,0,0,0-1.65.74c-1.63,1.1-1.27,3.52-1.11,5.48a14.83,14.83,0,0,1-1.69,8.19,2.92,2.92,0,0,1-2.59-2.44,19.52,19.52,0,0,1-.17-3.83c-.16-3.42-2-6.47-3.2-9.69-2.22-6.17-1.73-13-3.2-19.37-.44-1.89-1.15-3.88-2.75-5-2.12-1.47-5.06-.84-7.34.37s-4.31,2.92-6.78,3.67c-3.81,1.14-7.86-.23-11.66-1.43s-8.07-2.17-11.61-.36c-3.72,1.91-5.38,6.27-6.52,10.3a10.161,10.161,0,0,0-.55,3.44,31.242,31.242,0,0,1,.44,3.1c0,2.25-1.91,4-2.65,6.13-.46,1.31-.35,4.53-2.25,4.52-1.44,0-2.9-3.26-3.61-4.21C850.32,283.92,846.7,281.25,846.55,277.3Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b3e3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5007",
    "data-name": "Path 5007",
    d: "M848.32,265.63c-.44-2.49-2.6-4.29-3.65-6.59a7.468,7.468,0,0,1-.59-2.06,7.789,7.789,0,0,0,.59,4.29c1,2.28,3.15,4.07,3.63,6.51a6.461,6.461,0,0,0,.02-2.15Z",
    transform: "translate(-99.58 -31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5008",
    "data-name": "Path 5008",
    d: "M864.76,233.81a.805.805,0,0,0,0-.16,2.482,2.482,0,0,0-.12.47,1.15,1.15,0,0,0,.12-.31Z",
    transform: "translate(-99.58 -31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5009",
    "data-name": "Path 5009",
    d: "M891.93,228.44a1.774,1.774,0,0,1,0-.23c0,.07,0,.15,0,.22Z",
    transform: "translate(-99.58 -31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5010",
    "data-name": "Path 5010",
    d: "M929.08,265.53c-1.15,4.3-3.58,8.2-4.5,12.55-.54,2.58-.85,5.71-3.2,6.89a15.281,15.281,0,0,0-1.65.73c-1.35.92-1.33,2.74-1.19,4.46a2.92,2.92,0,0,1,1.19-2.22,13.592,13.592,0,0,1,1.65-.74c2.35-1.17,2.66-4.31,3.2-6.88.92-4.36,3.35-8.25,4.5-12.55a15.2,15.2,0,0,0,.5-5.17,15.737,15.737,0,0,1-.5,2.93Z",
    transform: "translate(-99.58 -31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5011",
    "data-name": "Path 5011",
    d: "M916.93,299.38a2.92,2.92,0,0,1-2.59-2.44,19.665,19.665,0,0,1-.17-3.84c-.16-3.41-2-6.47-3.2-9.68-2.22-6.17-1.73-13-3.2-19.37-.44-1.89-1.15-3.88-2.75-5-2.12-1.46-5.06-.83-7.34.37s-4.31,2.93-6.78,3.67c-3.81,1.15-7.86-.23-11.66-1.42s-8.07-2.18-11.61-.36c-3.72,1.91-5.38,6.27-6.52,10.29a10.212,10.212,0,0,0-.55,3.45,4.219,4.219,0,0,0,.1.7,15.177,15.177,0,0,1,.45-1.91c1.14-4,2.8-8.39,6.52-10.3,3.54-1.81,7.82-.83,11.61.36s7.85,2.57,11.66,1.43c2.47-.75,4.5-2.47,6.78-3.67s5.22-1.84,7.34-.37c1.6,1.09,2.31,3.08,2.75,5,1.47,6.39,1,13.2,3.2,19.37,1.15,3.22,3,6.27,3.2,9.69a19.516,19.516,0,0,0,.17,3.83,2.92,2.92,0,0,0,2.59,2.44,14.88,14.88,0,0,0,1.7-8.12,15,15,0,0,1-1.7,5.88Z",
    transform: "translate(-99.58 -31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5012",
    "data-name": "Path 5012",
    d: "M858.35,284.29c-.46,1.31-.35,4.53-2.25,4.52-1.44,0-2.9-3.25-3.61-4.2-2-2.71-5.26-5.2-5.85-8.69a7.121,7.121,0,0,0-.09,1.38c.15,3.95,3.77,6.62,5.94,9.54.71,1,2.17,4.2,3.61,4.21,1.9,0,1.79-3.21,2.25-4.52.74-2.12,2.6-3.88,2.65-6.13a6.12,6.12,0,0,0-.14-1.28C860.43,280.93,859,282.48,858.35,284.29Z",
    transform: "translate(-99.58 -31.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2635",
    "data-name": "Rectangle 2635",
    width: 3.36,
    height: 3.42,
    transform: "translate(99.75 446.6)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2636",
    "data-name": "Rectangle 2636",
    width: 3.36,
    height: 3.42,
    transform: "translate(99.75 446.6)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2637",
    "data-name": "Rectangle 2637",
    width: 3.28,
    height: 3.81,
    transform: "translate(384.45 164.94)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2638",
    "data-name": "Rectangle 2638",
    width: 3.28,
    height: 3.81,
    transform: "translate(384.45 164.94)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5013",
    "data-name": "Path 5013",
    d: "M487.34,481.53h0v-282h-.59c-156.31,0-283.15,126.08-284.42,282.09Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5014",
    "data-name": "Path 5014",
    d: "M487.34,481.53h0v-282h-.59c-156.31,0-283.15,126.08-284.42,282.09Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5015",
    "data-name": "Path 5015",
    d: "M487.34,481.53h0v-282h-.59c-156.31,0-283.15,126.08-284.42,282.09Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5016",
    "data-name": "Path 5016",
    d: "M484.34,478.53h0v-282h-.59c-156.31,0-283.15,126.08-284.42,282.09Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M484.34,478.53h0v-282h-.59c-156.31,0-283.15,126.08-284.42,282.09Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5018",
    "data-name": "Path 5018",
    d: "M594.55,677.37l4.19,2.63v5l-5.69-.88Z",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5019",
    "data-name": "Path 5019",
    d: "M594.55,677.37l4.19,2.63v5l-5.69-.88Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5020",
    "data-name": "Path 5020",
    d: "M194.92,679.37l-1.57.47v5l5.32-1.16-1.31-4.87Z",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5021",
    "data-name": "Path 5021",
    d: "M194.92,679.37l-1.57.47v5l5.32-1.16-1.31-4.87Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5022",
    "data-name": "Path 5022",
    d: "M499.27,517.46,292.93,716.34a284.38,284.38,0,0,0,405.38.16Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5023",
    "data-name": "Path 5023",
    d: "M499.27,512.46,292.93,711.34a284.38,284.38,0,0,0,405.38.16Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5024",
    "data-name": "Path 5024",
    d: "M499.27,512.46,292.93,711.34a284.38,284.38,0,0,0,405.38.16Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5025",
    "data-name": "Path 5025",
    d: "M499.27,517.46,292.93,716.34a284.38,284.38,0,0,0,405.38.16Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#4b55f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5026",
    "data-name": "Path 5026",
    d: "M382.99,475.06l6.87-4.7,1,2-7.84,5.73Z",
    fill: "#3acc6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5027",
    "data-name": "Path 5027",
    d: "M382.99,475.06l6.87-4.7,1,2-7.84,5.73Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5028",
    "data-name": "Path 5028",
    d: "M378.11,468.03l7.25-2.67,1,2-12.37,4.17Z",
    fill: "#ff748e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5029",
    "data-name": "Path 5029",
    d: "M378.11,468.03l7.25-2.67,1,2-12.37,4.17Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5030",
    "data-name": "Path 5030",
    d: "M377.2,459.28l7.66-.42v2l-12.87,1.35,1.15-2.59Z",
    fill: "#5e5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5031",
    "data-name": "Path 5031",
    d: "M377.2,459.28l7.66-.42v2l-12.87,1.35,1.15-2.59Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5032",
    "data-name": "Path 5032",
    d: "M484.44,490.36,207.09,553.52a285.393,285.393,0,0,1-6.51-60.75c0-.81,0-1.61,0-2.41Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#5e5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5033",
    "data-name": "Path 5033",
    d: "M484.44,490.36,207.09,553.52a285.393,285.393,0,0,1-6.51-60.75c0-.81,0-1.61,0-2.41Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M484.44,492.36,207.09,555.52a285.393,285.393,0,0,1-6.51-60.75c0-.81,0-1.61,0-2.41Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#5e5a6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M207.59,560a281.75,281.75,0,0,0,28.92,76.77L484.94,496.86Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ff748e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M207.59,560a281.75,281.75,0,0,0,28.92,76.77L484.94,496.86Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5037",
    "data-name": "Path 5037",
    d: "M208.59,562a281.749,281.749,0,0,0,28.92,76.77L485.94,498.86Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#ff748e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M488.89,501.88l-248,139.69.12.22a284.367,284.367,0,0,0,46.4,62.09l202-202Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#3acc6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M488.89,501.88l-248,139.69.12.22a284.367,284.367,0,0,0,46.4,62.09l202-202Z",
    transform: "translate(-99.58 -31.5)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M489.89,503.88l-248,139.69.12.22a284.37,284.37,0,0,0,46.4,62.09l202-202Z",
    transform: "translate(-99.58 -31.5)",
    fill: "#3acc6c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluPieChart);
export default __webpack_public_path__ + "static/media/illu-pieChart.9bb34562caa5121e1d3367be80ceb551.svg";
export { ForwardRef as ReactComponent };